'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'envelope-open-text';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f658';
var svgPathData = ['M32 176.1L32 416c0 35.3 28.7 64 64 64l176 0 0-178.3c-6.3-1.9-12.2-4.8-17.5-8.7L96.4 175.8 288 33.9 436.6 144 535.4 144c-4.3-7.4-10.2-14-17.3-19.3L321.5-21c-9.7-7.2-21.4-11-33.5-11s-23.8 3.9-33.5 11L57.9 124.7C41.6 136.8 32 155.8 32 176.1z', 'M368 192c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l160 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48l-160 0zm32 64l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l56 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEnvelopeOpenText = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;